"use client";

import { useState } from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { AuthProvider } from "@/context/AuthContext";
import { PiSocketProvider } from "@/context/PiSocketContext";
import { ToastContainer } from "react-toastify";

export default function BaseProviders({ children }) {
  const [queryClient] = useState(() => new QueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <PiSocketProvider>
          {children}
        </PiSocketProvider>

        <ToastContainer />
      </AuthProvider>
    </QueryClientProvider>
  );
}